import Transform from '@ember-data/serializer/transform';

export default class LowercaseTransform extends Transform {
  serialize() {
    console.log('LowercaseTransform', ...arguments);
  }
  deserialize(serialized) {
    return serialized && ('' + serialized).toLowerCase();
  }
}
